(function(){
  // mobile drawer
  var drawer=document.querySelector('[data-sh-drawer]');
  document.querySelectorAll('[data-sh-drawer-open]').forEach(function(b){b.addEventListener('click',function(){if(drawer){drawer.classList.add('is-open');document.body.style.overflow='hidden';}});});
  document.querySelectorAll('[data-sh-drawer-close]').forEach(function(b){b.addEventListener('click',function(){if(drawer){drawer.classList.remove('is-open');document.body.style.overflow='';}});});
  if(drawer){drawer.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){drawer.classList.remove('is-open');document.body.style.overflow='';});});}

  function money(cents,fmt){
    var v=(cents/100).toFixed(2);
    var parts=v.split('.');parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
    var n=parts.join('.');
    if(fmt&&fmt.indexOf('{{')>-1){return fmt.replace(/\{\{\s*\w+\s*\}\}/,n);}
    return '$'+n;
  }

  document.querySelectorAll('[data-sh-product]').forEach(function(root){
    var dataEl=root.querySelector('[data-sh-variants]');
    if(!dataEl)return;
    var variants=JSON.parse(dataEl.textContent);
    var fmt=root.getAttribute('data-money-format')||'';
    var idInput=root.querySelector('[data-sh-variant-id]');
    var priceNow=root.querySelector('[data-sh-price]');
    var priceWas=root.querySelector('[data-sh-compare]');
    var priceSave=root.querySelector('[data-sh-save]');
    var atc=root.querySelector('[data-sh-atc]');
    var atcLabel=root.querySelector('[data-sh-atc-label]');
    var colorLabel=root.querySelector('[data-sh-color-label]');
    var track=root.querySelector('[data-sh-track]');
    var slides=track?Array.prototype.slice.call(track.children):[];
    var dots=Array.prototype.slice.call(root.querySelectorAll('[data-sh-dot]'));
    var thumbs=Array.prototype.slice.call(root.querySelectorAll('[data-sh-thumb]'));
    var sticky=document.querySelector('[data-sh-sticky]');
    var stickyPrice=sticky?sticky.querySelector('[data-sh-sticky-price]'):null;

    function selected(){
      var opts=[];
      root.querySelectorAll('[data-sh-option]').forEach(function(fs){
        var c=fs.querySelector('input:checked');opts[parseInt(fs.getAttribute('data-sh-option'),10)]=c?c.value:null;
      });
      return opts;
    }
    function find(opts){
      return variants.find(function(v){return v.options.every(function(o,i){return opts[i]===undefined||opts[i]===null||o===opts[i];});});
    }
    function goTo(i){
      if(!track||!slides[i])return;
      track.scrollTo({left:slides[i].offsetLeft,behavior:'smooth'});
    }
    function setActive(i){
      dots.forEach(function(d,j){d.classList.toggle('is-active',j===i);});
      thumbs.forEach(function(t,j){t.classList.toggle('is-active',j===i);});
    }
    if(track){
      var t;track.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){var i=Math.round(track.scrollLeft/track.clientWidth);setActive(i);},60);},{passive:true});
    }
    dots.concat(thumbs).forEach(function(b){b.addEventListener('click',function(){goTo(parseInt(b.getAttribute('data-index'),10));});});

    function updatePackPrices(opts){
      root.querySelectorAll('[data-sh-pack-price]').forEach(function(el){
        var o=opts.slice();var idx=parseInt(el.getAttribute('data-sh-pack-option'),10);o[idx]=el.getAttribute('data-sh-pack-price');
        var v=find(o);if(!v)return;
        var b=el.querySelector('b'),s=el.querySelector('s');
        if(b)b.textContent=money(v.price,fmt);
        if(s){if(v.compare_at_price>v.price){s.textContent=money(v.compare_at_price,fmt);s.style.display='';}else{s.style.display='none';}}
      });
    }
    function update(fromUser){
      var opts=selected();var v=find(opts);
      updatePackPrices(opts);
      if(colorLabel){var c=root.querySelector('[data-sh-option="0"] input:checked');if(c)colorLabel.textContent=c.value;}
      if(!v){if(atc){atc.disabled=true;}if(atcLabel)atcLabel.textContent='Unavailable';return;}
      if(idInput)idInput.value=v.id;
      if(priceNow)priceNow.textContent=money(v.price,fmt);
      if(stickyPrice)stickyPrice.textContent=money(v.price,fmt);
      if(priceWas){if(v.compare_at_price>v.price){priceWas.textContent=money(v.compare_at_price,fmt);priceWas.style.display='';}else{priceWas.style.display='none';}}
      if(priceSave){if(v.compare_at_price>v.price){priceSave.textContent='Save '+money(v.compare_at_price-v.price,fmt);priceSave.style.display='';}else{priceSave.style.display='none';}}
      if(atc){atc.disabled=!v.available;}
      if(atcLabel){atcLabel.textContent=v.available?('Add to cart — '+money(v.price,fmt)):'Sold out';}
      if(fromUser&&v.featured_media&&track){
        var idx=slides.findIndex(function(s){return s.getAttribute('data-media-id')==String(v.featured_media.id);});
        if(idx>-1)goTo(idx);
      }
      if(fromUser&&root.hasAttribute('data-sh-update-url')&&window.history&&history.replaceState){
        var u=new URL(window.location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u.toString());
      }
    }
    root.querySelectorAll('[data-sh-option] input').forEach(function(i){i.addEventListener('change',function(){update(true);});});
    update(false);

    if(sticky&&atc){
      document.body.classList.add('sh-has-sticky');
      var io=new IntersectionObserver(function(es){es.forEach(function(e){var below=e.boundingClientRect.top<0;sticky.classList.toggle('is-visible',!e.isIntersecting&&below);});},{threshold:0});
      io.observe(atc);
      var sb=sticky.querySelector('[data-sh-sticky-btn]');
      if(sb)sb.addEventListener('click',function(){var f=atc.closest('form');if(f){if(f.requestSubmit)f.requestSubmit();else f.submit();}});
    }
  });
})();
